import { ArrayInput, RecordContextProvider, SimpleFormIterator, required, useNotify, useRefresh } from "react-admin";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import SpecializationRow from "./Partials/SpecializationRow";

const AddSpecializationsDialog = ({ buildingId, specializations = [] }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const excludeIds = specializations.map(s => s?.specializationId).filter(Boolean);

  const handleSubmit = async data => {
    const payload = {
      specializations: data.specializations?.map(({ specializationId, accreditationExpiryDate }) => ({
        specializationId,
        accreditationExpiryDate,
      })),
    };

    await dataProvider.customRequest(
      specialistRequests.addTrainingBuildingSpecializations(buildingId),
      payload,
      "POST",
    );
    refresh();
    notify("Успешно добавени специалности към учебната база", { type: "success" });
  };

  return (
    <RecordContextProvider value={undefined}>
      <FormModal
        titleContent="Добавяне на специалности към учебната база"
        dialogSize="md"
        defaultValues={{ specializations: [{}] }}
        onConfirm={handleSubmit}
        triggerButton={
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            sx={{ mt: 1 }}
          >
            Добави специалност
          </Button>
        }
      >
        <ArrayInput
          source="specializations"
          label="Специалности"
          validate={[required()]}
        >
          <SimpleFormIterator inline>
            <SpecializationRow excludeIds={excludeIds} />
          </SimpleFormIterator>
        </ArrayInput>
      </FormModal>
    </RecordContextProvider>
  );
};

export default AddSpecializationsDialog;
